import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import SearchIcon from '@mui/icons-material/Search';
import {alpha} from '@mui/material/styles';
import {makeStyles} from 'tss-react/mui';
import {Button} from 'wobi-web-common/dist/v2/index.js';
import {fireGtmEvent} from '../../utils/marketing.utils';

const NoOffers = ({handleNoOffers, onEditDetails}) => {
  const {classes} = useStyles();

  React.useEffect(() => {
    handleNoOffers();
    fireGtmEvent('NoOffersPage');
  }, []);

  return (
    <div className={classes.noOffers}>
      <div className={classes.card}>
        <div className={classes.iconCircle} aria-hidden='true'>
          <SearchIcon fontSize='inherit'/>
        </div>
        <h1 className={classes.title}>
          <FormattedMessage id='offers.empty.title'/>
        </h1>
        <p className={classes.lead}>
          <FormattedMessage id='offers.empty.description'/>
        </p>
        <Button size='lg' onClick={onEditDetails}>
          <FormattedMessage id='offers.empty.editDetails'/>
        </Button>
        <p className={classes.note}>
          <FormattedMessage id='offers.empty.note'/>
        </p>
      </div>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  noOffers: {
    width: '100%',
    maxWidth: 640,
    margin: '0 auto',
    padding: 'clamp(28px, 5vw, 56px) 0',
  },
  card: {
    padding: 'clamp(28px, 5vw, 44px) clamp(22px, 5vw, 40px)',
    borderRadius: 16,
    background: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    textAlign: 'center',
  },
  iconCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 76,
    height: 76,
    margin: '0 auto 22px',
    borderRadius: '50%',
    background: alpha(theme.palette.primary.main, 0.1),
    color: theme.palette.primary.main,
    fontSize: 30,
  },
  title: {
    margin: '0 0 14px',
    color: theme.palette.text.primary,
    fontSize: 'clamp(21px, 3vw, 25px)',
    fontWeight: 800,
    lineHeight: 1.3,
  },
  lead: {
    maxWidth: '60ch',
    margin: '0 auto 26px',
    color: theme.palette.text.secondary,
    fontSize: theme.typography.pxToRem(15),
    lineHeight: 1.65,
  },
  note: {
    margin: '22px 0 0',
    color: theme.palette.text.secondary,
    fontSize: theme.typography.pxToRem(12.5),
    lineHeight: 1.6,
  },
}));

NoOffers.propTypes = {
  handleNoOffers: PropTypes.func.isRequired,
  onEditDetails: PropTypes.func.isRequired,
};

export default NoOffers;
